import { type FunctionComponent } from 'react';
import { StyledLink } from '../../common-components/link/styled-link.component';
import AdobePdfSvg from '../../svgs/adobe-pdf.svg';

export type ResourceElementProps = {
	name: string;
	url: string;
};

const ResourceElement: FunctionComponent<{ name: string; url: string }> = ({ name, url }): JSX.Element => {
	return (
		<StyledLink url={url} openInNewTab={true} className={'pb3 f7 db'}>
			<AdobePdfSvg className="h2 w2 v-mid" data-testid="AdobePdfSvg" />
			<span className={'pl3 f5'}>{name}</span>
		</StyledLink>
	);
};

export type ManufacturerResourcesProps = {
	resources: ResourceElementProps[];
};

export const ManufacturerResources: FunctionComponent<ManufacturerResourcesProps> = ({ resources }): JSX.Element | null => {
	if (!resources || !resources.length) {
		return null;
	}
	const resourceElements: JSX.Element[] = resources.map(({ url, name }, index) => <ResourceElement key={index} url={url} name={name} />);

	return (
		<div>
			<h3 className="f4">Manufacturer Resources</h3>
			{resourceElements}
		</div>
	);
};
